import React, { Component } from "react";
import "../../styling/home/home.css";
import Header from "../shared/header.js";
import Footer from "../shared/footer.js";
import Events from "../shared/events.js";
import HomeHeader from "./home-header.js";

class Home extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchText: null
    };
  }

  // Called after the Panel receives a new searchText
  didSearchText(text) {
    this.setState({
      searchText: text
    });
  }

  render() {
    const searchText = this.state.searchText;

    return (
      <div className="home">
        <HomeHeader didSearchText={text => this.didSearchText(text)} />
        <Events searchText={searchText} key={searchText} />
        <Footer />
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/component/home/home.js